import { apiClient } from './api-client';
import { decodeJwtDeviceKey, decodeJwtUsername } from './decode-jwt-username';
import { scheduleSilentRefresh } from './silent-refresh';
import { tokenStorage } from './token-storage';

let refreshPromise: Promise<boolean> | null = null;

/**
 * Calls /auth/refresh exactly once even if invoked concurrently.
 * Returns true on success (tokens updated), false on failure.
 * On success, also schedules the next silent refresh.
 */
export async function tryRefreshOnce(): Promise<boolean> {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    try {
      const refreshToken = tokenStorage.getRefreshToken();
      const email = tokenStorage.getEmail();
      const accessToken = tokenStorage.getAccessToken();
      const username = accessToken ? decodeJwtUsername(accessToken) : '';
      const deviceKey = accessToken ? decodeJwtDeviceKey(accessToken) : '';

      if (!refreshToken || !email) {
        return false;
      }
      if (!username) {
        return false;
      }

      const { data, error } = await apiClient.POST('/auth/refresh', {
        body: {
          email,
          refreshToken,
          username,
          ...(deviceKey ? { deviceKey } : {}),
        },
      });
      if (error || !data) {
        return false;
      }

      tokenStorage.updateAccessToken(data.accessToken);
      scheduleSilentRefresh(data.accessToken);
      return true;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
